import UpdateShopArticleRequestModelBase from '../_generated/modelBases/update-shop-article-request-model-base';

export default class UpdateShopArticleRequestModel extends UpdateShopArticleRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
